import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';

export default class SystemLockUIListener extends UIListener {
    protected typesToRemove: Array<string> = ['RAD.RADFoundation.ProblemDomain.User'];

    constructor() {
        super();
    }

    public onDetailViewReady(context: DetailViewContext) {
        let factory = context.getUIFactory('LoginExceptions') as ControlFactory;

        if (factory == null) {
            return;
        }

        let types = factory.detailViewItem.listView.types;

        if (types.length > 2) {
            for (let i = types.length-1; i >= 0; i--) {
                if (this.typesToRemove.indexOf(types[i].name) > -1) {
                    types.splice(i, 1);
                }
            }
        }
    }
}

ComponentManager.setUIListener('SystemLockUIListener', SystemLockUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.SystemLockUIListener', SystemLockUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');